"use strict";

import angular from "angular";

import template from "./empty-contract-plan.component.html";
import "./themes/empty-contract-plan.component.scss";
import "./themes/empty-contract-plan.component-dark.scss";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { ContractPlansService } from "../../../presentation/services/ContractPlan/ContractPlanService";
import { Events } from "../../../presentation/services/Events/Events";

export class EmptyContractPlanComponent {
    Events = new Events();

    constructor(DSNDialogService) {
        this.DSNDialogService = DSNDialogService;

        this.User = new UserDataAdapter().user();

        this.ContractPlansService = new ContractPlansService({
            DSNDialogService: this.DSNDialogService,
            User: this.User
        });
    }

    $onInit() {
        this.ContractPlansService.setAccountingEntity(this.accountingData);
    }

    async onSubmitUpgrade($event) {
        this.ContractPlansService.requestContract($event);
    }
}

EmptyContractPlanComponent.$inject = ["DSNDialogService"];

const name = "emptyContractPlanComponent";
const def = {
    controller: EmptyContractPlanComponent,
    bindings: {
        title: "@",
        description: "@",
        accountingData: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
